import { render, staticRenderFns } from "./DesktopFooter.vue?vue&type=template&id=4c645d7c&scoped=true"
import script from "./DesktopFooter.vue?vue&type=script&lang=ts"
export * from "./DesktopFooter.vue?vue&type=script&lang=ts"
import style0 from "./DesktopFooter.vue?vue&type=style&index=0&id=4c645d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c645d7c",
  null
  
)

export default component.exports